import $ from "jquery";

// Unique value validation
$.validator.addMethod("unique", function (value, element, parameters) {
	var isUnique = true;

	$(element).closest("form").find(parameters).not(element).each(function () {
		if (isUnique && value != null && $(this).val().toLowerCase() === value.toLowerCase()) {
			isUnique = false;
		}
	});

	return isUnique;

});
$.validator.unobtrusive.adapters.addSingleVal("unique", "selector");